import { jsx as _jsx } from "react/jsx-runtime";
import { Box as MuiBox } from '@mui/material';
import { forwardRef } from 'react';
export const Flex = forwardRef((props, ref) => {
    return _jsx(MuiBox, { ref: ref, display: "flex", ...props });
});
export const Column = forwardRef((props, ref) => {
    return _jsx(MuiBox, { ref: ref, display: "flex", flexDirection: "column", justifyContent: "center", ...props });
});
export const Row = forwardRef((props, ref) => {
    return _jsx(MuiBox, { ref: ref, display: "flex", flexDirection: "row", alignItems: "center", ...props });
});
